$(function() {

    // @vars -------------------------------------------------------------------
    const ajax_url = CCM_REL + '/index.php/tools/packages/selector_tool/ajax.php';
    const $arrow_prev = $('.triple-p-selector-slider-prev');
    const $arrow_next = $('.triple-p-selector-slider-next');
    let slide = 0;

    // @functions --------------------------------------------------------------
    function initSlider() {
        let num_splides = document.querySelectorAll('section.triple-p-selector .splide');

        if (num_splides.length > 0) {
            let splide = new Splide('section.triple-p-selector .splide', {
                start: slide,
                speed: 700,
                perPage: 1,
                rewind: true,
                pagination: false,
                arrows: false
            });

            $(document).on('click', '.triple-p-selector-slide-icons > li > a', function(e) {
                e.preventDefault();
                let slide_nr = parseInt(this.getAttribute('data-slide')) - 1;
                splide.go(slide_nr);
            });

            $(document).on('click', '.triple-p-selector-slider-prev', function(e) {
                e.preventDefault();
                splide.go('<');
            });

            $(document).on('click', '.triple-p-selector-slider-next', function(e) {
                e.preventDefault();
                splide.go('>');
            });

            splide
                .on('mounted move', function() {
                    slide = splide.index;
                });

            splide.mount();
        }
    }

    // @event listeners --------------------------------------------------------
    $(document).on('click', '.triple-p-selector a[data-node-id]', function(e) {
        try {
            e.preventDefault();

            $.ajax({
                url: ajax_url,
                data: {
                    node_id: this.dataset.nodeId
                },
                type: 'GET',
                dataType: 'html',
                beforeSend: function() {
                    // console.log('send AJAX call');
                },
                success: function(response) {
                    $('section.triple-p-selector').html(response);
                    initSlider();
                }
            });

        } catch (err) {
            alert(err.message);
        }
    });

    // @init -------------------------------------------------------------------
    // @note: not much going on yet
});
